import React  from 'react';
const value = {
  path:"amortization",
  title:"Mortgage Amortization",
  date_modified:"Oct 2019",
  date_created:"Oct 2019",
  content:
[
<p align="justify">
  Amortization is the length of time it will take to pay back the principal and incurred interest of your mortgage. In Canada, the maximum amortization for a conventional mortgage (above 20% down-payment) is 30 years; for a high-ratio mortgage, the maximum amortization allowed is 25 years. Taking more time to pay off your mortgage means you will be making smaller mortgage payments; but this also means you will end up paying more in interest, since you are borrowing money for a longer period of time. When choosing the length of your amortization, you need to balance mortgage payment affordability with interest costs. Once you decide on an amortization period, it does not mean you are stuck with it. Everytime you renegotiate your mortgage (when the term ends), you are able to change the amortization; this is an opportunity to take advantage of any changes in your financial situation since your last negotiation. You are also able to alter the amortization by making additional payments, by either increasing your payment frequency, or by making lump-sum payments. Since the profits of the lender are affected by how long you borrow the money, mortgage lenders don’t always allow these additional payments; you’ll need to confirm that your terms allow you to make these payments, without incurring penalties.
</p>
  ,
<p align="justify">
  Below is an example of how amortization length can affect the cost of interest and size of mortgage payments on a $300,000 mortgage with a 4% rate.
</p>
,
<table>
  <tr>
    <th>
      Amortization
    </th>
    <th>
      Mortgage Payment
    </th>
    <th>
      Interest Paid
    </th>
  </tr>
  <tr>
    <td>
      10 years
    </td>
    <td>
      $3,032
    </td>
    <td>
      $63,919
    </td>
  </tr>
  <tr>
    <td>
      15 years
    </td>
    <td>
      $2,214
    </td>
    <td>
      $98,540
    </td>
  </tr>
  <tr>
    <td>
      25 years
    </td>
    <td>
      $1,578
    </td>
    <td>
      $173,418
    </td>
  </tr>
</table>
,
<p>
  Clearly, amortization has a significant effect on your mortgage. By doubling your payments, in this scenario, you could save more than $100,000 in interest payments!
</p>
],
  tags:["mortgage","amortization"]
}

export default value



// WEBPACK FOOTER //
// src/content/mortgageAmortization.js